import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { FirebaseProvider } from './firebase.provider';
import { AuthInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';
import { RoleVoter } from './role.voter';

@NgModule({
    imports: [CommonModule],
    providers: [
        AuthService,
        RoleVoter,
        FirebaseProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
})
export class AuthModule {}
